(function(angular) {
    'use strict';

    var baseAttrName = 'apCheckbox';

    // interpolated string attribute to generate visible label text automatically
    var labelAttribute = baseAttrName + 'Label';

    // interpolated string attribute to be used in case the checkbox isn't supposed to have visible label text
    // but the text should show up for screenreaders
    var hiddenLabelAttribute = baseAttrName + 'HiddenLabel';

    var currentId = 0;

    // override this behavior for all input[type=checkbox]
    angular.module('aprima-core-ui').directive('input', [
        '$compile',
        '$log',
        apCheckBox,
    ]);

    function apCheckBox(
        $compile,
        $log
    ) {

        var directive = {
            restrict: 'E',
            compile: compile,
        };

        return directive;


        function compile(
            tElement,
            tAttrs
        ) {
            if(tAttrs.type !== 'checkbox' || tElement.hasClass('native')) {
                return;
            }

            var returnValue = {
                post: postLink,
            };

            // add the class to wrap this, so it all looks right
            tElement.parent().addClass('ap-checkbox-wrapper');

            // set the tabindex to 0 if it's not set, so this checkbox can be focusable in the document's source order
            // this attribute isn't interpolated, so it's ok that it doesn't get $compiled
            if(!tAttrs.tabindex) {
                tAttrs.$set('tabindex', 0);
            }

            return returnValue;
        }

        function postLink(
            scope,
            element,
            attrs
        ) {
            var errors = [];

            var labelText;
            var checkboxLabel;

            var checkBoxId = attrs.id;
            if(!checkBoxId) {
                checkBoxId = newId();
                attrs.$set('id', checkBoxId);

                errors.push('This checkbox doesn\'t have the id attribute filled in. An id should be added. A temp id "' + checkBoxId + '" was created as a fallback,' +
                    ' and if a NEW label is generated for this checkbox, the label will be associated to it.');
            }

            if(attrs[hiddenLabelAttribute]) {
                labelText = attrs[hiddenLabelAttribute];
                checkboxLabel = angular.element('<label class="ap-checkbox-hidden-text"></label>');
            }
            else if(attrs[labelAttribute]) {
                labelText = attrs[labelAttribute];
                checkboxLabel = angular.element('<label></label>');
            }
            else {
                var nextNode = element.next()[0];
                var nextNodeName = nextNode && nextNode.nodeName && nextNode.nodeName.toLowerCase();

                // without a label next to it, the checkbox, won't show up, so add one, even if no text was passed in
                if(nextNodeName !== 'label') {
                    labelText = checkBoxId;
                    checkboxLabel = angular.element('<label class="ap-checkbox-hidden-text"></label>');

                    errors.push('This checkbox doesn\'t have a label after it and the ' +
                        labelAttribute + ' attribute and ' +
                        hiddenLabelAttribute + ' attribute are not filled in. One of these options needs to be used for correct behavior.' +
                        ' A label with the id as the text was created as a fallback.');
                }
                else {
                    printErrors();
                    return;
                }
            }

            checkboxLabel.attr('for', checkBoxId);
            checkboxLabel.text(labelText);
            element.after(checkboxLabel);
            $compile(checkboxLabel)(scope);

            printErrors();
            return;


            function printErrors() {
                if(errors.length) {
                    // print out errors that have the actual dom element, instead of just the template element,
                    // so they can be more easily traced to the dom
                    errors.forEach(function(error) {
                        $log.warn(error, element[0]);
                    });
                }
            }
        }
    }

    function newId() {
        var id = 'ap-checkbox-' + currentId++;
        return id;
    }

})(window.angular);
